exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-label {\n\tmax-width: 100%;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfloat: left;\n\tborder-radius: 3px;\n\tpadding: 5px 10px 5px 5px;\n\tcolor: black;\n\tborder: 1px solid #ccc;\n\tfont-weight: 400;\n\tmargin: 0 8px 8px 0;\n\ttext-transform: capitalize;\n\twhite-space: nowrap;\n}\n", ""]);

// exports
